import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {environment} from '../../../../../environments/environment';
import {CfgARFeeDiscountModel} from '../../../../models/accountsReceivable/cfg-ar-fee-discount.model';

@Injectable({
  providedIn: 'root'
})
export class FeeDiscountsService {
  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      console.error(error);
      return of(result as T);
    };
  }

  getClientLocations(tdocid: string ): Observable<any[]> {
    let url: string;
    const method: string = 'operatory-configuration/tdo-clients-locations/' + tdocid;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getClients(): Observable<any[]> {
    let url: string;
    const method: string = 'operatory-configuration/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getDiscountsForDoctorLocations(doctorId: string): Observable<CfgARFeeDiscountModel[]> {
    let url: string;
    const method: string = 'accountReceivable/getDiscountsForDoctorLocations/' + doctorId;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  saveFeeDiscounts(feeDiscounts: CfgARFeeDiscountModel[]): Observable<CfgARFeeDiscountModel[]> {
    return this.http.post<CfgARFeeDiscountModel[]>(`/api/accountReceivable/saveFeeDiscounts`, feeDiscounts);
  }
}
